import React, { useState } from 'react';

import { Card, CardBody } from 'reactstrap';
import { useSelector } from 'react-redux';
import { positiveMonetizationItemsByPromo } from '../../selectors/monetizationItem';
import DataTableNext from '../Common/DataTable/DataTableNext';
import { getLabel } from '../Common/DataTable/tableHelpers';

import roles from '../../config/roles';

const hideSensitiveDataString = '***';

const PositiveMonetizationItemInsights = ({ userId, role }) => {
  const positiveMonetizationItems = useSelector(
    positiveMonetizationItemsByPromo(userId),
  );
  const monetizationOrders = useSelector(
    (state) => state.MonetizationOrder.monetizationOrders,
  );
  const showSensitiveData = useSelector(
    (state) => state.Layout.showSensitiveData,
  );

  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(30);

  const columns = [
    {
      title: 'Monetization Order',
      name: 'monetizationOrderId',
      getCellValue: (row) =>
        showSensitiveData
          ? getLabel(row.monetizationOrderId, monetizationOrders)
          : hideSensitiveDataString,
      filter: showSensitiveData ? undefined : 'disabled',
      sorting: showSensitiveData ? undefined : 'disabled',
    },
    {
      title: 'Customer Promo',
      name: 'promoName',
    },
    {
      title: 'Closures',
      name: 'count',
      width: 110,
      summary: 'sum',
    },
  ];

  const revenueColumn = [roles.ADMIN, roles.SUPER_ADMIN].includes(role)
    ? [
        {
          title: 'Revenues',
          name: 'revenues',
          width: 180,
          formatterComponent: ({ value }) =>
            `€ ${showSensitiveData ? value.toFixed(2) : '**'}`,
          filter: showSensitiveData ? undefined : 'disabled',
          sorting: showSensitiveData ? undefined : 'disabled',
          //the summary would publish the real total of a masked column
          summary: showSensitiveData ? 'sum' : undefined,
        },
      ]
    : [];

  return (
    <Card>
      <CardBody>
        <DataTableNext
          loading={false}
          rows={positiveMonetizationItems}
          columns={[...columns, ...revenueColumn]}
          filters={filters}
          onFiltersChange={setFilters}
          sorting={sorting}
          onSortingChange={setSorting}
          currentPage={currentPage}
          onCurrentPageChange={setCurrentPage}
          pageSize={pageSize}
          onPageSizeChange={setPageSize}
          tableId="positive-monetization-items"
        />
      </CardBody>
    </Card>
  );
};

export default PositiveMonetizationItemInsights;
